import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import {
  HelpClosingSideDrawerComponent,
  HelpSideDrawerContentDirective,
  HelpSideDrawerFooterDirective,
  HelpSideDrawerPreTitleActionsDirective,
  HelpSideDrawerTitleActionsDirective,
} from './help-closing-side-drawer/help-closing-side-drawer.component';

@NgModule({
  declarations: [
    HelpClosingSideDrawerComponent,
    HelpSideDrawerContentDirective,
    HelpSideDrawerFooterDirective,
    HelpSideDrawerPreTitleActionsDirective,
    HelpSideDrawerTitleActionsDirective,
  ],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatToolbarModule],
  exports: [
    HelpClosingSideDrawerComponent,
    HelpSideDrawerContentDirective,
    HelpSideDrawerFooterDirective,
    HelpSideDrawerPreTitleActionsDirective,
    HelpSideDrawerTitleActionsDirective,
  ],
})
export class HelpSideDrawerModule {}
